import { useUsersInfiniteQuery } from '../../api';

import type { UsersSearchRequestModel } from '../types/search-request.model';
import type { UserModel } from '../types/users.model';

export const useUsersDictionary = (searchRequest: UsersSearchRequestModel) => {
	const query = useUsersInfiniteQuery(searchRequest);

	const dictionary = query.currentData?.pages
		.flatMap((page) => page.items)
		.reduce(
			(acc, user) => {
				if (user.id) {
					acc[user.id] = user;
				}
				return acc;
			},
			{} as Record<string, UserModel>
		);

	return {
		...query,
		data: dictionary,
		currentData: dictionary,
	};
};
